import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const AddEditOrderName = props => {
  const {
    onCancel,
    setOccasionNameHandler,
    updateFavouriteOrder,
    occasionName,
    isNameExist,
    isInValid,
    isEditOrderName = false,
    onClearTextHandler,
    disaableButton,
    editFavHeading = false,
    isAddFavOrderBox = false,
  } = props;
  const {
    CANCEL,
    SAVE,
    OCCASSION_ADD_HEADING,
    OCCASSION_EDIT_HEADING,
    ORDER_PLACEHOLDER,
    NAME_EXIST,
    OCCASION_NAME_VALIDATION,
    EDIT_FAVOURITE_HEADING,
    SAVE_FAV_ORDER,
    PLEASE_FILL_OUT_THIS_FIELD
  } = TRANSLATE_MAPPING_KEY;

  const editHeadingTitle = editFavHeading ? EDIT_FAVOURITE_HEADING : OCCASSION_EDIT_HEADING;
  const editOrderName = isEditOrderName ? editHeadingTitle : OCCASSION_ADD_HEADING;
  const errorCss = isInValid ? 'special-char-error' : 'name-exist-error';
  return (
    <div>
      <div className='InputHeading'>{translateWithI18Next(isAddFavOrderBox ? SAVE_FAV_ORDER : editOrderName)}</div>
      <form>
        <div className='inputLookUpNumbox'>
          <input
            value={occasionName}
            type='text'
            data-testid='occasion-input'
            className={isNameExist || isInValid ? 'error-input' : 'occasion-input-box'}
            required
            maxLength={50}
            onChange={event => setOccasionNameHandler(event, isEditOrderName)}
            title={translateWithI18Next(PLEASE_FILL_OUT_THIS_FIELD)}
          />
          <label>{translateWithI18Next(ORDER_PLACEHOLDER)}</label>
          {(isNameExist || isInValid) && (
            <div className={`error-text-container ${errorCss}`}>
              <ImageComponent srcFile={IMAGE_PATH.Error} />
              <span className='error-text' data-testid='error-text'>
                {translateWithI18Next(isInValid ? OCCASION_NAME_VALIDATION : NAME_EXIST)}
              </span>
            </div>
          )}
          {occasionName !== '' ? (
            <img
              src={IMAGE_PATH.clearTextIcon}
              alt='clear-text-btn'
              data-testid='clear-text-btn'
              className='clearTextIcon'
              onClick={() => onClearTextHandler()}
            />
          ) : null}
        </div>
      </form>
      <div className='buttonItems'>
        <ButtonComp
          data-testid='occasion-cancel-button'
          className='button whiteButton blackBorder closebtn-cls'
          onClick={() => onCancel()}
        >
          {translateWithI18Next(CANCEL)}
        </ButtonComp>
        <ButtonComp
          disabled={disaableButton}
          data-testid='submit-button'
          className='button blackButton blackBorder save-button'
          onClickHandler={() => updateFavouriteOrder()}
        >
          {translateWithI18Next(SAVE)}
        </ButtonComp>
      </div>
    </div>
  );
};

export default AddEditOrderName;
